import { PlusCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { t } from "i18next";
import { makeAutoObservable } from "mobx";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { loadUsers } from "src/business/user/apiUsers";
import { makeUsersColumns } from "src/business/user/makeUsersColumns";
import { MdmTable } from "src/components/MdmTable";
import { PageLayout } from "src/components/PageLayout";
import { RtColumnsSettingsButton } from "src/components/ReactiveTable/components/RtColumnsSettings";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { ToolBox2 } from "src/components/ToolBox2";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";
import { ZUser } from "src/types/ZUser";

import { ManagementUsersAndRoles } from "../ManagementUsersAndRoles";

const makeUserListStore = () =>
  makeAutoObservable({
    tableStore: new RtStore<ZUser, {}>({
      rowKey: "id",
      loader: loadUsers(),
    }),
  });

export const UsersList: React.FC = observer(() => {
  const [userListStore, columns] = useMemo(
    () => [makeUserListStore(), makeUsersColumns()],
    [],
  );
  const { tableStore } = userListStore;

  const tools = (
    <>
      <RtColumnsSettingsButton store={tableStore} />
      <Link to={makeUrl(PageUrl.managementUserNew)}>
        <Button type="primary" icon={<PlusCircleOutlined />}>
          {t("Create")}
        </Button>
      </Link>
    </>
  );

  return (
    <PageLayout title={t("Users")}>
      <ManagementUsersAndRoles tab="users">
        <ToolBox2 extraTools={tools} paddingMode="page">
          <MdmTable<ZUser, {}>
            store={tableStore}
            columns={columns}
            resizableColumns
            rowClick={{
              type: "link",
              builder: (row) =>
                makeUrl(PageUrl.managementUserEdit, { id: row.id }),
            }}
          />
        </ToolBox2>
      </ManagementUsersAndRoles>
    </PageLayout>
  );
});
